const LocationIcon = ({ className }: { className?: string }) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.02999 2.42998C3.81768 1.64229 4.88602 1.19977 5.99999 1.19977C7.11395 1.19977 8.18229 1.64229 8.96999 2.42998C9.75768 3.21768 10.2002 4.28602 10.2002 5.39998C10.2002 6.51395 9.75768 7.58229 8.96999 8.36998L5.99999 11.34L3.02999 8.36998C2.63993 7.97997 2.33053 7.51695 2.11943 7.00735C1.90833 6.49776 1.79968 5.95157 1.79968 5.39998C1.79968 4.84839 1.90833 4.30221 2.11943 3.79261C2.33053 3.28302 2.63993 2.81999 3.02999 2.42998ZM5.99999 6.59998C6.31825 6.59998 6.62347 6.47355 6.84851 6.24851C7.07356 6.02347 7.19999 5.71824 7.19999 5.39998C7.19999 5.08172 7.07356 4.7765 6.84851 4.55145C6.62347 4.32641 6.31825 4.19998 5.99999 4.19998C5.68173 4.19998 5.3765 4.32641 5.15146 4.55145C4.92641 4.7765 4.79999 5.08172 4.79999 5.39998C4.79999 5.71824 4.92641 6.02347 5.15146 6.24851C5.3765 6.47355 5.68173 6.59998 5.99999 6.59998Z"
    />
  </svg>
  //#247BF2
);

export default LocationIcon;
